module.exports = __webpack_public_path__ + "static/ai-3-5ac837902990514ecf8306823e755750.webp";